import { Routes, Route, RoutesProps } from "react-router-dom";
import React from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import SetPassword from "../components/Login/SetPassword";
import { CartProvider } from "../mobile/CartContext";

// Static imports to make navigation instantaneous and remove dynamic network latency / white screens
import Login from "../components/Login/Login";
import Signup from "../components/Signup/Signup";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
import OTPVrification from "../components/Login/VerifyOtp";
import Dashboard from "../pages/DashboardView/DashboardView";
import TableView from '../pages/TableView/TableView';
import OrderView from '../pages/TableView/OrderView';
import MobileLogin from "../mobile/Login";
import MobileTables from "../mobile/Tables";
import MobileMenu from "../mobile/Menu";
import MobileDishes from "../mobile/Dishes";
import MobileCart from "../mobile/Cart";
import MobileOrders from "../mobile/Orders";
import MobilePayment from "../mobile/Payment";
import MobileOrderDetails from "../mobile/OrderDetails";
import MobileOrderSuccess from "../mobile/OrderSuccess";
import MobilePaymentDetail from "../mobile/PaymentDetail";
import MobileSplitBill from "../mobile/SplitBill";
import MobileQrCode from "../mobile/QrCode";
import MobileReceipt from "../mobile/Receipt";
import MobileEmailReceipt from "../mobile/EmailReceipt";
import MobileEmailSent from "../mobile/EmailSent";
import MobileSplitBillPayment from "../mobile/SplitBillPayment";
import MobileProfile from "../mobile/Profile";

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  return (
    <>
      <div id="main-wraper">
        <CartProvider>
          <Routes>
            <Route path="/" element={<MobileLogin />} />
            <Route path="/login" element={<MobileLogin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify-otp" element={<OTPVrification />} />
            <Route path="/mobile" element={<MobileLogin />} />
            <Route path="/mobile/login" element={<MobileLogin />} />
            <Route element={<ProtectedRoute authenticationPath="/login" />}>
              <Route path="/mobile/tables" element={<MobileTables />} />
              <Route path="/mobile/menu/:tableNo" element={<MobileMenu />} />
              <Route path="/mobile/menu" element={<MobileMenu />} />
              <Route path="/mobile/dishes/:categoryKey/:tableNo" element={<MobileDishes />} />
              <Route path="/mobile/dishes/:categoryKey" element={<MobileDishes />} />
              <Route path="/mobile/cart" element={<MobileCart />} />
              <Route path="/mobile/orders" element={<MobileOrders />} />
              <Route path="/mobile/payment" element={<MobilePayment />} />
              <Route path="/mobile/order-details/:tableNo" element={<MobileOrderDetails />} />
              <Route path="/mobile/order-success" element={<MobileOrderSuccess />} />
              <Route path="/mobile/payment/:tableNo" element={<MobilePaymentDetail />} />
              <Route path="/mobile/split-bill/:tableNo" element={<MobileSplitBill />} />
              <Route path="/mobile/qr-code/:tableNo" element={<MobileQrCode />} />
              <Route path="/mobile/receipt/:tableNo" element={<MobileReceipt />} />
              <Route path="/mobile/email-receipt/:tableNo" element={<MobileEmailReceipt />} />
              <Route path="/mobile/email-sent" element={<MobileEmailSent />} />
              <Route path="/mobile/split-bill-payment/:tableNo" element={<MobileSplitBillPayment />} />
              <Route path="/mobile/profile" element={<MobileProfile />} />
            </Route>
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/table-view" element={<TableView />} />
              <Route path="/order-view/:id" element={<OrderView />} />
            </Route>

          </Routes>
        </CartProvider>
      </div>
    </>
  );
};

export default Navigation;
